import { TableCell } from '../components/Table';
import Badge from '../components/Badge';
import { DateObject } from '../models/DateObject';

const PageTable: TableCell<any>[] = [
  {
    label: 'Name',
    value: 'name',
    sorter: true,
    key: 'name',
  },
  {
    label: 'Roles',
    value: (data) => {
      return (
        <div>
          {(data.roles_names ?? []).map((role: string) => (
            <Badge key={role} color="blue">
              {role}
            </Badge>
          ))}
        </div>
      );
    },
  },
  {
    label: 'Created date',
    sorter: true,
    key: 'created_at',
    value: (data) => {
      const date = new DateObject(data.createdAt.toISOString());
      return <div className="flex w-full">{date.formatted}</div>;
    },
  },
  {
    label: 'Updated date',
    sorter: true,
    key: 'updated_at',
    value: (data) => {
      const date = new DateObject(data.updatedAt.toISOString());
      return <div className="flex w-full">{date.formatted}</div>;
    },
  },
];

export default PageTable;
